<div class="dashboard-container">
  <div class="row">
    <div class="col-lg-3 col-md-12 text-center">
      <app-grocy-calendar />
    </div>

    <div class="col-lg-9 col-md-12 text-center">
      <div class="row">
        <div class="col-lg-2 text-center"></div>

        <div class="col-lg-8 text-center">
          <app-time-clock />
        </div>

        <div class="col-lg-2 text-center">
          <app-grocy-actions />
        </div>
      </div>

      <app-weather-next-hour-forecast />
      <app-weather-meteogram />
    </div>
  </div>
</div>
